/*
 * This file was automatically generated. Do not make any changes
 * directly as they may be overwritten.
 *
 * To update this file, run `yarn run generate-api`.
 */
import { apiService } from "assets/scripts/domain/apiService";
/* tslint:disable */
export const EXIT_URL = "/api/session/exit";
export const EXIT_BEACON_URL = "/api/session/exitbeacon";
export const RECORD_EVENT_URL = "/api/session/event";
export function exit() {
    return apiService.post(EXIT_URL, false, {});
}
export function exitBeacon() {
    return apiService.post(EXIT_BEACON_URL, false, {});
}
export function recordEvent(data) {
    return apiService.post(RECORD_EVENT_URL, false, {
        data
    });
}
/* tslint:enable */ 



// WEBPACK FOOTER //
// ./src/generated/api/session.ts